document.querySelectorAll('.chart.linechart').forEach(function (el) {
    var balloonText = "[[category]]<br/>Cumulative Return: [[CumulativePerf]]<br/>Monthly Return: [[MonthlyPerf]]"
    var mobile = screen.width < 768
    var chart = AmCharts.makeChart(el, {
        type: "serial",
        theme: "light",
        dataDateFormat: "YYYY-MM-DD",
        dataProvider: perf,
        categoryField: "Date",
        categoryAxis: {
            gridAlpha: 0,
            parseDates: true,
            labelsEnabled: !mobile
        },
        valueAxes: [
            {
                position: 'left',
                title: mobile ? '' : 'Return (%)'
            }
        ],
        responsive: {
            enabled: true
        },
        chartCursor: {
            bulletsEnabled: true,
            bulletSize: 20,
            oneBalloonOnly: true,
            categoryBalloonColor: "#D8292F",
            categoryBalloonDateFormat: 'MMM YYYY',
        },
        balloon: {
            adjustBorderColor: true,
            borderThickness: 0,
            borderRadius: 5,
            fillColor: '#eeeeee',
            color: '#000000',
        },
        legend: {
            useGraphSettings: true,
            markerDisabledColor: '#ddd',
            enabled: !mobile
        },
        graphs: [
            {
                type: 'column',
                title: 'Monthly Return',
                valueField: 'MonthlyPerf',
                lineColor: '#eef3f6',
                fillColors: '#eef3f6',
                fillAlphas: 1,
                lineThickness: 1,
                columnWidth: 10,
                balloonText: balloonText
            },
            {
                type: 'line',
                title: 'Cumulative Return',
                valueField: 'CumulativePerf',
                lineColor: '#D8292F',
                balloonText: balloonText
            }
        ],
        export: {
            enabled: false
        }
    });
})

document.querySelectorAll('.chart.piechart').forEach(function (el) {
    var chart = AmCharts.makeChart(el, {
        type: "pie",
        theme: "light",
        hideCredits: true,
        dataProvider: pie,
        labelRadius: -35,
        labelText: "[[title]] [[percents]]%",
        responsive: {
            enabled: true,
            rules: [
                {
                    maxWidth: 550,
                    overrides: {
                        labelsEnabled: true,
                        legend: {
                            marginLeft: 40,
                        }
                    }
                },
                {
                    maxWidth: 756,
                    overrides: {
                        legend: {
                            marginLeft: 40,
                        }
                    }
                },
            ]
        },
        legend: {
            enabled: false
        },
        startDuration: 0,
        titleField: "title",
        valueField: "value",
        colorField: "color",
        radius: "48%",
        innerRadius: "60%",
        labelsEnabled: false,
        export: {
            enabled: false
        }
    })
})

document.querySelectorAll('.graph-block').forEach(function (el) {
    var mobile = screen.width < 768
    var key = el.dataset.key
    var gd = window.graphData[key]

    var getData = function (series, data) {
        return data.map((item) => {
            var newItem = {
                Date: item.Date,
            }
            series.forEach((s, i) => {
                newItem[getLinePropertyName(s)] = item.Values[i];
            });
            return newItem;
        })
    }
    var getLinePropertyName = function (title) {
        return "value" + title.replace(/[^a-zA-Z0-9]+/g, '-')
    }
    var getLines = function (series, data) {
        var lines = series.map((s, i) => {
            return {
                type: 'line',
                title: s,
                lineThickness: 2,
                valueField: getLinePropertyName(s),
                balloonText: `[[category]]<br/>${s}: [[${getLinePropertyName(s)}]]`
            };
        });
        return lines;
    }

    AmCharts.makeChart(el, {
        type: "serial",
        theme: "light",
        dataDateFormat: "YYYY-MM-DD",
        dataProvider: getData(gd.Series, gd.GraphDataPoints),
        categoryField: "Date",
        categoryAxis: {
            gridAlpha: 0,
            parseDates: true,
            labelsEnabled: !mobile
        },
        titles: gd.Titles,
        marginTop: 25,
        colors: ["#bd142d", "#5ca2ba", "#95c5a6", "#ecd31c", "#d79fbd", "#CD0D74", "#CC0000", "#00CC00", "#0000CC", "#DDDDDD", "#999999", "#333333", "#990000"],
        valueAxes: [{
            position: 'left',
            title: mobile ? '' : gd.YAxis
        }],
        responsive: {
            enabled: true
        },
        legend: {
            useGraphSettings: true,
            markerDisabledColor: '#ddd',
            enabled: !mobile
        },
        graphs: getLines(gd.Series, gd.GraphDataPoints),
    })

})